import {
  SHOW_MODAL_GIA_HAN_NOPHAITHU,
  SHOW_MODAL_GIA_HAN_NOPHAITHU_SUCCESS,
  SHOW_MODAL_GIA_HAN_NOPHAITHU_FAILURE,
  POST_GIA_HAN_NOPHAITHU,
  POST_GIA_HAN_NOPHAITHU_SUCCESS,
  POST_GIA_HAN_NOPHAITHU_FAILURE,
} from "./actionTypes";

export const showModalGiaHanNoPhaiThu = (dataSearch) => ({
  type: SHOW_MODAL_GIA_HAN_NOPHAITHU,
  dataSearch,
});

export const showModalGiaHanNoPhaiThuSuccess = (data) => ({
  type: SHOW_MODAL_GIA_HAN_NOPHAITHU_SUCCESS,
  payload: data,
});

export const showModalGiaHanNoPhaiThuFailure = () => ({
  type: SHOW_MODAL_GIA_HAN_NOPHAITHU_FAILURE,
});

export const postGiaHanNoPhaiThu = (dataPost) => ({
  type: POST_GIA_HAN_NOPHAITHU,
  dataPost,
});

export const postGiaHanNoPhaiThuSuccess = (data) => ({
  type: POST_GIA_HAN_NOPHAITHU_SUCCESS,
  payload: data,
});

export const postGiaHanNoPhaiThuFailure = () => ({
  type: POST_GIA_HAN_NOPHAITHU_FAILURE,
});
